import {DiscountModel} from "../Models/ProductModel";
import {OrderProductModel} from "../Models/OrderModel";

export const useGetReductionFromQuantity = (): [
    (total: number, unitPriceTTC: number, quantity: number, discount: DiscountModel, otherOrderProducts: OrderProductModel[]) => number,
    (total: number, unitPriceTTC: number, quantity: number, discount: DiscountModel, otherOrderProducts: OrderProductModel[]) => number ] => {

    function getReduction(total: number, unitPriceTTC: number, quantity: number, discount: DiscountModel, otherOrderProducts: OrderProductModel[]):number {
        const otherOrderProductsWithSamePrice = otherOrderProducts.filter(p => p.unitPriceTTC === unitPriceTTC)
        const quantityAlreayInOrder = otherOrderProductsWithSamePrice.map(p => p.quantity || 0).reduce((prev, curr) => prev + curr, 0)
        const reductionAlreadyGetted = otherOrderProductsWithSamePrice.filter(p => p.discountName === discount.name && p.discount !== 0).length
        const quantityToCheck = quantityAlreayInOrder - (reductionAlreadyGetted * discount.discount.rateTotal) + quantity

        if(quantityToCheck < discount.discount.rateTotal) {return 0}

        const multiple = Math.floor(quantityToCheck / discount.discount.rateTotal) > 0 ? Math.floor(quantityToCheck / discount.discount.rateTotal) : 1

        return total / quantity * (discount.discount.rateTotal - discount.discount.rate) * multiple;
    }

    const getTotalMinusReduction = (total: number, unitPriceTTC: number, quantity: number, discount: DiscountModel, otherOrderProducts: OrderProductModel[]): number => {
        const reduction = getReduction(total, unitPriceTTC, quantity, discount, otherOrderProducts)
        return reduction ? total - reduction : total
    }

    return [getTotalMinusReduction, getReduction]
}
